// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-71993a62","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./FrontEnd/modulos/conciliacao-projeto/componentes/PernasTransitoria.vue
// module id = 1215
// module chunks = 0